import { many, attr} from 'redux-orm';
import Model from '../base-model';

/**
 * Section
 * @typedef {Object} Section
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {boolean} isCurrent
 * @property {Unit[]} units
 */

export class Section extends Model {

    toString() {
        return `Section: ${this.title}`
    }
}

Section.modelName = 'Section';

Section.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    isCurrent: attr(),
    units: many('Unit', 'section'),
}